import Reveal from "../components/Reveal";

const LINES = ["NO WI-FI.", "NO TRAFFIC.", "NO DISTRACTIONS."];

export default function Detox() {
  return (
    <section data-testid="detox-section" className="border-y border-brass/15 px-6 py-28 sm:px-12 sm:py-40 lg:px-20">
      <div className="mx-auto max-w-5xl text-center">
        {LINES.map((l, i) => (
          <Reveal key={l} delay={i * 0.15}>
            <p
              data-testid={`detox-line-${i}`}
              className={`font-serif text-4xl font-light leading-[1.15] tracking-tight sm:text-6xl lg:text-7xl ${
                i === 2 ? "italic text-brass" : "text-ivory"
              }`}
            >
              {l}
            </p>
          </Reveal>
        ))}
        <Reveal delay={0.5}>
          <div className="mx-auto mt-14 max-w-2xl space-y-5 text-base font-light leading-relaxed text-ivory/70 sm:text-lg">
            <p>There are places designed to keep you connected.</p>
            <p>The Jamoon is designed to help you disconnect.</p>
            <p className="text-ivory">
              What you get instead is increasingly rare:{" "}
              <span className="font-serif italic text-brass">time without interruption.</span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
